import React from 'react';
import {
  IconShield,
  IconShieldCheck,
  IconCamera,
  IconLock,
} from '@tabler/icons-react';

const ServiceCard = ({ IconComponent, title, items }) => (
  <div className="bg-white rounded-2xl p-5 flex flex-col gap-3 shadow-sm border border-[rgba(150,99,118,0.1)]">
    <div className="w-10 h-10 flex items-center justify-center bg-[rgba(255,244,248,1)] rounded-xl">
      <IconComponent size={22} className="text-[#966376]" stroke={1.5} />
    </div>
    <h4 className="text-[#0B2549] font-sans font-semibold text-base">{title}</h4>
    <ul className="flex flex-col gap-1.5">
      {items.map((item, i) => (
        <li key={i} className="text-[#6D7E94] text-xs flex items-start gap-1.5">
          <span className="text-[#966376] mt-0.5 shrink-0">•</span>
          {item}
        </li>
      ))}
    </ul>
  </div>
);

const cards = [
  {
    IconComponent: IconShield,
    title: 'Manned Guarding',
    items: [
      'Static entry / exit guards',
      'Perimeter patrolling',
      'Access control management',
    ],
  },
  {
    IconComponent: IconShieldCheck,
    title: 'Executive Protection',
    items: [
      'Bouncers & bodyguards',
      'High-profile event security',
      'Specialized personal protection',
    ],
  },
  {
    IconComponent: IconCamera,
    title: 'Technical Surveillance',
    items: [
      'CCTV monitoring',
      'Fire alarm response',
      'Biometric access control',
    ],
  },
  {
    IconComponent: IconLock,
    title: 'Industrial Security',
    items: [
      'Material movement tracking',
      'Gate office management',
      'Loss prevention',
    ],
  },
];

const SecurityGuardingSection = () => (
  <section className="py-12 sm:py-16 px-4 sm:px-6 bg-[#FFF4F8]">
    <div className="max-w-[75rem] mx-auto">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
        {/* Left: cards grid — order swapped for visual rhythm */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 order-2 lg:order-1">
          {cards.map((card, i) => (
            <ServiceCard key={i} {...card} />
          ))}
        </div>
        {/* Right: text */}
        <div className="text-center lg:text-left order-1 lg:order-2">
          <h2 className="text-[#966376] font-sans text-base sm:text-lg font-semibold uppercase tracking-widest">
            SECURITY & GUARDING
          </h2>
          <h3
            style={{ lineHeight: 1.25 }}
            className="text-[#0B2549] font-regrade text-2xl sm:text-3xl md:text-4xl font-bold mt-3 mb-5"
          >
            Comprehensive Security<br className="hidden sm:block" /> Solutions, Tailored to You
          </h3>
          <p className="text-[#6D7E94] text-sm sm:text-base font-[500] leading-relaxed max-w-lg mx-auto lg:mx-0">
            Security services are focused on risk mitigation, asset protection, and ensuring
            the safety of your personnel. From static manned guards to advanced CCTV
            integration, we bring trained professionals and technology together for
            complete peace of mind.
          </p>
        </div>
      </div>
    </div>
  </section>
);

export default SecurityGuardingSection;
